module.exports = __webpack_public_path__ + "img/sample-min-2.43755073.png";